import { render } from "./branch-details.vue?vue&type=template&id=259e5e1a"
import script from "./branch-details.vue?vue&type=script&lang=js"
export * from "./branch-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__